import { render, staticRenderFns } from "./WatermarkBg.vue?vue&type=template&id=752f3b4e&scoped=true"
import script from "./WatermarkBg.vue?vue&type=script&lang=js"
export * from "./WatermarkBg.vue?vue&type=script&lang=js"
import style0 from "./WatermarkBg.vue?vue&type=style&index=0&id=752f3b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752f3b4e",
  null
  
)

export default component.exports